export class FeedbackRequest {
  correlationId: string;
  timestamp: string;
  rating: number;
  comment?: string;
  technicalIssue?: string;
}
